import * as React from 'react';
import { useHistory } from 'react-router-dom';
import ToastReporter from './ToastReporter';


const AccessContactRoleReporter = () => {

    const history = useHistory();

    const detaildata = [
        {
            key: "Editor", value: "Local Government Users who have a Role of “Editor” will be able to access your local"
                + " government's AFR via LOGERX using their email address as their username. Primary Editors"
                + " are also able to edit who is able to access your AFR. Primary Editors are responsible for"
                + " maintaining these accounts."
        },
        {
            key: "Contact", value: "Local Government Contacts who have a Role as “Contact” will be included in mass"
                + " communications regarding changes to statutes, rules, manuals, etc."
        },
        {
            key: "Third Party", value: "Third Party users can have a Role of “Auditors”, “Management Company”, or “Other”."
                + " These users will be able to access your local governments AFR via LOGERX using their email address as their"
                + " username. They will not be able to submit your AFR on your behalf."
        },
    ];

    const [shouldRender, setShouldRender] = React.useState<boolean | null>(false);

    React.useEffect(() => {
        if (history.location.pathname == '/EntityManagementA' ||
            history.location.pathname == '/EntityManagement') {
            setShouldRender(true);
        }
        else {
            setShouldRender(false);
        }
    }, [history.location.pathname])

    return (
        <React.Fragment>
            {
                shouldRender == true ?
                    <ToastReporter topic="Access Roles" style="" details={detaildata} showReadMoreMaxChars={0} />
                    : <></>
            }

        </React.Fragment>
    );
}


export default AccessContactRoleReporter;